<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="PropertyId"
      ref="list"
      unit="用户"
      urlHash="finance/dealings/agingreceivable"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="false"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.getRpRcvAgingSum"
      :get-horizontal-func="api.list"
      :get-subtotal-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户:" label-width="100px">
          <el-input
            clearable
            v-model="params.TradeUnitName"
            placeholder="请输入客户名称"
          />
        </el-form-item>
        <el-form-item label="分析日期:"  label-width="100px">
          <el-date-picker
            v-model.trim="params.AnalysisDate"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/rp/rpReceiptDoc").default,
      trendShow: true,
      show: false,
      subList: [],
      params: {
        TradeUnitName: "",
        AnalysisDate: this.$commonJs.getToday(),
      },
    };
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/agingreceivable")) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == "CurrentIncome");
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
      const findIndex1 = this.$refs.list.tableList.findIndex(item => item.tableName == "CurrentPay");
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1);
      const findIndex2 = this.$refs.list.tableList.findIndex(item => item.tableName == "CurrentBalance");
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1);
      const findIndex3 = this.$refs.list.tableList.findIndex(item => item.tableName == "OverdueBalance");
      if (findIndex3 >= 0) this.$refs.list.tableList.splice(findIndex3, 1);
      const findIndex5 = this.$refs.list.tableList.findIndex(item => item.label == "1-22天");
      if (findIndex5 >= 0) {
        const i = this.$refs.list.tableList[findIndex5].children.findIndex(item => item.tableName == 'FirstBalance');
      if (i >= 0) this.$refs.list.tableList[findIndex5].children.splice(i, 1);
      }
      const findIndex6 = this.$refs.list.tableList.findIndex(item => item.label == "23-32天");
      if (findIndex6 >= 0) {
        const i = this.$refs.list.tableList[findIndex6].children.findIndex(item => item.tableName == 'SecondBalance');
      if (i >= 0) this.$refs.list.tableList[findIndex6].children.splice(i, 1);
      }
      const findIndex7 = this.$refs.list.tableList.findIndex(item => item.label == "33天以上");
      if (findIndex7 >= 0) {
        const i = this.$refs.list.tableList[findIndex7].children.findIndex(item => item.tableName == 'ThirdBalance');
      if (i >= 0) this.$refs.list.tableList[findIndex7].children.splice(i, 1);
      }
    }
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
